import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ManagementContainerModel,
  ManagementContainerTypeModel,
  ManagementPriceListCombinedDetailedModel,
  ManagementVoyageModel,
} from '@data-layer/models/management';

@Component({
  selector: 'optimization-view-container',
  templateUrl: './optimization-view-container.component.html',
  styleUrls: ['./optimization-view-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptimizationViewContainerComponent {
  @Input() public totalBooked: number;
  @Input() public container: ManagementContainerModel;
  @Input() public voyage: ManagementVoyageModel;
  @Input() public priceList: ManagementPriceListCombinedDetailedModel;
  @Input() public containerType: ManagementContainerTypeModel;
  @Output() public create: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  public get isDefaultContainer(): boolean {
    return this.containerType?.isDefault;
  }

  public getTotalBooked(): number {
    return this.totalBooked;
  }
}
